.spinnercontainer{
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: gray;
    border-radius: 20px;
}
.spinnercontainer .spinnerloading {
    width: 60px;
    height: 100%;
}